<template>
	<div class="p-grid p-pb-6">
		<div class="p-col-12 p-pt-1 p-pb-1">
        <h2>{{$t('support.title')}}</h2>
        <div class="irinox-form" >

          <p class="p-pt-1 p-pb-3">
            {{$t('support.text1')}}<br>
            {{$t('support.text2')}}<br>
            {{$t('support.text3')}}<br>
          </p>

          <div class="p-grid">
            <div class="p-col-12 p-md-12 p-lg-10 p-xl-7">
              <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col">
                      <label for="reasons">{{$t('support.reason')}}</label>
                      <Dropdown id="reasons" v-model="reason" :options="reasons" optionLabel="name" optionValue="id" 
                        :placeholder="$t('support.reason_ph')" :class="{'p-invalid':v$.reason.$invalid && submitted}"/>
                  </div>
              </div>
              <div class="p-fluid p-formgrid p-grid" v-if="!hideForm">
                  <div class="p-field p-col">
                      <label for="model">{{$t('support.model')}}</label>
                      <InputText id="model" type="text" v-model="model" :placeholder="$t('support.model_ph')" :class="{'p-invalid':v$.model.$invalid && submitted}"/>
                  </div>
                  <div class="p-field p-col">
                      <label for="serialNumber">{{$t('support.serial_number')}}</label>
                      <InputText id="serialNumber" type="text" v-model="serialNumber" :placeholder="$t('support.serial_number_ph')" :class="{'p-invalid':v$.serialNumber.$invalid && submitted}"/>
                  </div>
              </div>
              <div class="p-fluid p-formgrid p-grid" v-if="!hideForm">
                  <div class="p-field p-col">
                      <label for="message">{{$t('support.message')}}</label>
                      <Textarea id="message" v-model="message" rows="5" :placeholder="$t('support.message_ph')" :class="{'p-invalid':v$.message.$invalid && submitted}" />
                  </div>
              </div>
              <div class="p-fluid p-formgrid p-grid" v-if="!hideForm">
                  <div class="p-col">
                      
                  </div>
                  <div class="p-col p-text-right">
                      <Button :label="$t('support.send_request')" autofocus @click="save(!v$.$invalid)" />
                  </div>
              </div>
            </div>
          </div>

          <div v-if="showCyberResilienceActWarning" class="p-p-3 p-shadow-2 p-rounded p-d-flex p-ai-center" style="background-color: #f4f4f4; color: #002445; gap:10px">
            <i class="pi pi-info-circle p-mr-2" style="font-size: 1.5em;"></i>
            <div>{{$t('support.cyber_resilience_act_warning')}}: <a :href="craLink" target="_blank" style="text-decoration: underline;">{{ $t('support.cyber_resilience_act_warning_link') }}</a></div>
          </div>

          <img class="support-pg" src="assets/irinox/images/support-bg.svg" :alt="$t('support.title')"/>

        </div>
		</div>
	</div>

  <IrinoxDialogDark :visible="successDialog" mode="success" :message="$t('support.success_dialog')"
    :life="5000" @update:visible="successDialog = $event" />

  <IrinoxDialogDark :visible="errorDialog" mode="error" :message="$t('support.error_dialog')"
    :life="5000" @update:visible="errorDialog = $event" />

  <IrinoxDialogDark :visible="errorDialogSerial" mode="error" :message="$t('support.error_dialog_serial')"
    :life="5000" @update:visible="errorDialogSerial = $event" />

  <IrinoxDialogDark :visible="blockingErrorDialog" mode="error" :message="$t('support.error_dialog')"
    :life="0" @update:visible="blockingErrorDialog = $event" />

</template>

<script>
import MailService from '../../service/MailService';
import { required, requiredIf } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import IrinoxDialogDark from '../IrinoxDialogDark.vue';

export default {
    components: {
        IrinoxDialogDark,
    },
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
          reasons: [{
            id: 0,
            name: this.$t('support.reasons.reason0'),
          },{
            id: 1,
            name: this.$t('support.reasons.reason1'),
          },{
            id: 2,
            name: this.$t('support.reasons.reason2'),
          },{
            id: 3,
            name: this.$t('support.reasons.reason3'),
          },{
            id: 4,
            name: this.$t('support.reasons.reason4'),
          },{
            id: 5,
            name: this.$t('support.reasons.reason5'),
          },{
            id: 6,
            name: this.$t('support.reasons.reason6'),
          },{
            id: 7,
            name: this.$t('support.reasons.reason7'),
          },{
            id: 8,
            name: this.$t('support.reasons.reason8'),
          },{
            id: 9,
            name: this.$t('support.reasons.reason9'),
          },{
            id: 11,
            name: this.$t('support.reasons.reason11'),
          },{
            id: 99,
            name: this.$t('support.reasons.reason99'),
          },{
            id: 10,
            name: this.$t('support.reasons.reason10'),
          }],
          reason: null,
          model: null,
          serialNumber: null,
          message: null,
          submitted: false,
          successDialog: false,
          errorDialog: false,
          errorDialogSerial: false,
          blockingErrorDialog: false,
        };
    },
    computed: {
        personaltoken: function() {
            return this.$store.getters['userdata/personaltoken'];
        },
        hideForm: function() {
          return this.reason==99;
        },
        showCyberResilienceActWarning: function() {
          return this.reason==99;
        },
        craLink: function() {
          let supportedLangs = ['it', 'en'];
          let currentLang = this.$functions.language(this.$i18n.locale);
          return "https://product-security.irinoxprofessional.com/" + (supportedLangs.includes(currentLang) ? currentLang : 'en') + "/";
        }
    },
    watch: {
      'reason': 'changeReason'
    },
    validations() {
        return {
          reason: { required },
          model: { 
            required: requiredIf(function() {
              return this.reason>0;
            }) 
          },
          serialNumber: { 
            required: requiredIf(function() {
              return this.reason>0;
            }) 
          },
          message: { required }
        }
    },
    created() {
      this.mailService = new MailService();
    },
    mounted() {
    },
    methods: {
      changeReason(newValue, oldValue) {
        if(newValue===0) {
          this.message = this.$t('support.accessibility_message_template', { device: this.$window.navigator.userAgent});
        } else if(newValue===11) {
          this.message = this.$t('support.dataact_message_template');
        } else if((newValue!==0 && oldValue===0) || (newValue!==11 && oldValue===11)) {
          this.message = null;
        }
      },  
      save(isFormValid) {
        this.submitted = true;

        if (!isFormValid) {
          return;
        }

        let data = {};
        data.reason = this.reason;
        data.model = this.model;
        data.serialNumber = this.serialNumber;
        data.message = this.message;
        data.attachments = [];

        // console.log(JSON.stringify(data));

        this.mailService.support(this.personaltoken, data)
          .then((data) => {
            if(data.code=='200') {
              this.submitted = false;
              this.successDialog = true;
              this.reason = null;
              this.model = null;
              this.serialNumber = null;
              this.message = null;
            } else if(data.code==='404') {
              this.errorDialogSerial = true;
            } else {
              this.errorDialog = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.errorDialog = true;
          });
      }
    }
}
</script>

<style scoped>
p {
  color: #262626;
}

textarea {
  width: 100%;
}

.p-fluid .p-button {
  width: auto;
  border: 5px solid #FFFFFF;
}

.support-pg {
  max-width: 100%;
  position: fixed;
  right: 10px;
  bottom: 10px;
  z-index: -1;
}

</style>